import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DoctorProfile } from '@cureskin/api-client-rn';
import { AppConfig } from '../../../app.config';


@Component({
  selector: 'discomfort-ticket',
  templateUrl: './discomfort-ticket.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class DiscomfortTicketComponent {
    @Input('pendingTicket') pendingTicket:any;
    @Output('trackVoiceEvent') trackVoiceEvent:EventEmitter<any> = new EventEmitter();
    @Input('userName') userName:any;
    @Input('defaultDoctorImage') defaultDoctorImage:string;
    @Input('audioMessageInTicket') audioMessageInTicket:any;
    @Input('activeDiscomfortTicket') activeDiscomfortTicket:any;
    @Input('userDoctor') userDoctor:DoctorProfile;
    @Input('user') user:any;
    @Input('showDiscomfortBanner') showDiscomfortBanner:boolean;
    audioUrl: string;
    excludedSubCategories: string[] = this.appConfig.Shared?.ExcludedSubCategories?.SubCategories;

  constructor(
    public appConfig: AppConfig,
    public router: Router,
  ) {}

  handleClick(event:any):void {
    this.trackVoiceEvent.emit(event);
  }

  async viewQuery(ticketId: string): Promise<void> {
    await this.router.navigate([`/support/ticket/${ticketId}`],
    { queryParams: { username: this.user?.get('username') } });
  }
}
